class ChatPresence {
  statusIcon (data) {
    switch (data?.status) {
      case 'online':
        return 'mdi-chat-outline'
      case 'busy':
        return 'mdi-chat-processing-outline'
      case 'away':
        return 'mdi-chat-sleep-outline'
      case 'offline':
      default:
        return 'mdi-chat-remove-outline'
    }
  }

  statusColor (data) {
    switch (data?.status) {
      case 'online':
        return 'green'
      case 'busy':
        return 'red accent-4'
      case 'away':
        return 'orange'
      case 'offline':
      default:
        return 'blue-grey lighten-1'
    }
  }

  statusTextKey (data) {
    switch (data?.status) {
      case 'online':
        return 'chat.presence.online'
      case 'away':
        return 'chat.presence.away'
      case 'busy':
        return 'chat.presence.busy'
      case 'offline':
      default:
        return 'chat.presence.offline'
    }
  }
}

export default new ChatPresence()
